import { jsx as y } from "react/jsx-runtime";
import { C as E, M as _ } from "../../index-CZTsB7cN.js";
import { forwardRef as u } from "react";
import { PopoverContext as S } from "./hooks/usePopoverContext.js";
import b from "./hooks/usePopover.js";
import { MarketPopoverTrigger as k } from "./subcomponents/MarketPopoverTrigger.js";
import { MarketPopoverContent as A } from "./subcomponents/MarketPopoverContent.js";
const I = (r, t) => {
  const {
    children: o,
    container: n = "div",
    disableFocusManager: p = !1,
    interaction: a,
    layerMode: i = "portal",
    viewportMargin: s = E,
    offset: l = _,
    onCloseEnd: c,
    onCloseStart: f,
    onOpenEnd: m,
    onOpenStart: v,
    placement: P = "bottom",
    portalRootId: d,
    role: M = "dialog",
    strategy: C = "absolute",
    ...O
  } = r, R = Object.prototype.hasOwnProperty.call(HTMLElement.prototype, "popover"), g = i === "native" && R ? "native" : "portal", e = b({
    interaction: a,
    viewportMargin: s,
    offset: l,
    placement: P,
    popoverRef: t,
    role: M,
    strategy: C,
    ...O
  });
  return /* @__PURE__ */ y(
    S.Provider,
    {
      value: {
        container: n,
        disableFocusManager: p,
        layerMode: g,
        onCloseEnd: c,
        onCloseStart: f,
        onOpenEnd: m,
        onOpenStart: v,
        portalRootId: d,
        ...e
      },
      children: typeof o == "function" ? o({ setPositionReference: e.refs.setPositionReference }) : o
    }
  );
}, H = Object.assign(u(I), {
  displayName: "MarketPopover",
  Trigger: k,
  Content: A
});
export {
  H as MarketPopover
};
